import React, {useEffect} from 'react'
import {Image, Transformer} from "react-konva";
import useImage from "use-image";
import {parseInt} from "lodash";
import {BLOCK_SNAP_SIZE} from "../../../constants/design.constant";

const ImageItem = ({
                       shapeProps, isSelected, onSelect, onChange, handleGuidelineDragEnd, handleGuidelineDragMove
                   }) => {
    const [image] = useImage(shapeProps.src, 'anonymous');
    const shapeRef = React.useRef();

    /*useEffect(() => {
        if (image) {
            console.log(image?.height, image?.width)
        }
    }, [image])*/

    const handleTransformEnd = (event) => {
        const node = shapeRef.current || undefined;

        const scaleX = node.scaleX();
        const scaleY = node.scaleY();
        node.scaleX(1);
        node.scaleY(1);

        const width = parseInt(String(Math.max(5, (node.width() * scaleX) + 10)));
        const height = parseInt(String(Math.max(5, (node.height() * scaleY) + 10)));

        node.offsetX(width / 2);
        node.offsetY(height / 2);

        onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            scaleX: node.scaleX(),
            scaleY: node.scaleY(),
            offsetX: node.offsetX(),
            offsetY: node.offsetY(),
            totalWidth: width,
            totalHeight: height,
            width: width,
            height: height,
            rotation: node.rotation(),
        });
    }

    const handleDragEnd = (event) => {
        const node = shapeRef.current || undefined;

        const currentTextRef = event.target;
        currentTextRef.position({
            x: Math.round(currentTextRef.x() / BLOCK_SNAP_SIZE) * BLOCK_SNAP_SIZE,
            y: Math.round(currentTextRef.y() / BLOCK_SNAP_SIZE) * BLOCK_SNAP_SIZE
        });

        onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            scaleX: node.scaleX(),
            scaleY: node.scaleY(),
            offsetX: node.offsetX(),
            offsetY: node.offsetY(),
            totalWidth: node.width(),
            totalHeight: node.height()
        });
    }

    return (
        <>
            {!shapeProps?.isBackgroundImage && !shapeProps?.isRepeatImage && !shapeProps?.isTemplate && image && image?.width > 0 && image?.height > 0 &&
                <Image
                    ref={shapeRef}
                    {...shapeProps}
                    name={'object'}
                    image={image}
                    draggable
                    onTransformEnd={handleTransformEnd}
                    onDragMove={(e) => {
                        handleDragEnd(e);
                        handleGuidelineDragMove(e);
                    }}
                    onDragEnd={(e) => {
                        handleDragEnd(e);
                        handleGuidelineDragEnd(e);
                    }}
                />
            }
        </>
    )
}

export default ImageItem
